import { Component, Output, Input, EventEmitter } from "@angular/core";

@Component({
  selector: "custom-button",
  templateUrl: "custom-button.html",
})
export class CustomButtonComponent {
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Output() ionChange: EventEmitter<any> = new EventEmitter();

  constructor() {}

  clickHandler(e) {
    this.ionChange.emit(this.checked);
  }
}



// WEBPACK FOOTER //
// ./src/components/custom-button/custom-button.ts